import { Button, Drawer, Hairline, Label } from "@components";
import classNames from "classnames/bind";
import { useState } from "react";
import { Add } from "shared/components/Add";
import { ForEach, If } from "shared/components/control-statements";
import { Icon } from "shared/components/core/Icon";
import { SuccessIcon } from "shared/components/Icons";
import { InputSearch } from "shared/components/InputSearch";
import styles from "styles/pages/cdp/database-management.module.scss";
const css = classNames.bind(styles);

export default function Groups({
  visible,
  groups = [],
  onClose,
  openCreateGroup,
  variableName,
  onSave,
}) {
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [success, setSuccess] = useState(false);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const filteredGroups = (groups || []).filter((c) => {
    if (c?.name === "Ignorados") return false;

    return !!search
      ? (c?.name || "").toLowerCase().includes(search.toLowerCase())
      : true;
  });

  const confirm = async () => {
    setLoading(true);

    onSave();

    setTimeout(() => {
      setSuccess(true);
      setLoading(false);
    }, 2000);
  };

  return (
    <Drawer
      visible={visible}
      title={success ? "Sucesso" : "Agrupar"}
      subtitle={
        success
          ? `${variableName} movido para "${selectedGroup?.name}"`
          : "Mover"
      }
      showBackButton={!success}
      onClose={() => {
        onClose();
        setSuccess(false);
        setSelectedGroup(null);
      }}
    >
      <If cond={!success}>
        <div className={styles.groupContainer}>
          <div
            className={css({
              ignored: true,
              selected: selectedGroup?.name === "Ignorados",
            })}
            onClick={() =>
              setSelectedGroup((prev) =>
                prev?.name === "Ignorados"
                  ? null
                  : {
                      name: "Ignorados",
                    }
              )
            }
          >
            <div className="d-flex align-center">
              <Icon name="fa-ban" light />
              <p>Ignorados</p>
            </div>
            <span className={styles.quantity}>0</span>
          </div>

          <Hairline className="mt-20 mb-20" />

          <Label>Grupos ({(filteredGroups || []).length})</Label>
          <InputSearch
            placeholder="Buscar por..."
            design="two"
            onChange={(e) => setSearch(e.target.value)}
          />
          <Add
            className="mt-15 mb-15"
            onClick={openCreateGroup}
            text="Criar novo grupo"
          />

          <If cond={filteredGroups.length > 0}>
            <div className={styles.groups}>
              <ForEach
                items={filteredGroups}
                render={(g) => {
                  return (
                    <div
                      className={css({
                        group: true,
                        selected: selectedGroup?.id === g.id,
                      })}
                      onClick={() =>
                        setSelectedGroup(() =>
                          selectedGroup?.id === g.id ? null : g
                        )
                      }
                    >
                      <div className="d-flex align-center">
                        <div className={styles.icon}>
                          <i className="fal fa-layer-group" />
                        </div>
                        <p className={styles.name}>{g.name}</p>
                      </div>
                      <span className={styles.quantity}>
                        {g?.quantity || 0}
                      </span>
                    </div>
                  );
                }}
              />
            </div>
          </If>
        </div>

        {!!selectedGroup && (
          <div className={styles.footer}>
            <Button
              design="primary"
              onClick={confirm}
              className="w-100"
              loading={loading}
              disabled={loading}
            >
              Mover para grupo selecionado
            </Button>
          </div>
        )}
      </If>

      <If cond={success}>
        <div className={styles.success}>
          <div className={styles.successIcon}>
            <SuccessIcon color="#1f1f1f" size={14} />
          </div>
        </div>
        <div className={styles.footer}>
          <Button
            design="primary"
            className="w-100"
            onClick={() => {
              onClose();
              setSuccess(false);
              setSelectedGroup(null);
            }}
          >
            Fechar
          </Button>
        </div>
      </If>
    </Drawer>
  );
}
